import { Injectable } from '@angular/core';
import { ApiLegalDocuments } from '@app/core/legal-documents/api-legal-documents';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { toCamelCasedKeys } from '@app/shared/utils/to-camel-cased-keys';
import { BaseParamsService } from '@app/core/base-params.service';
import { LOCALE_HEADER, LOYALTY_CLUB_SLUG_HEADER } from '@app/core/consts';

@Injectable({
  providedIn: 'root',
})
export class ApiLegalDocumentsHttpService {

  public getDocuments(): Observable<ApiLegalDocuments> {
    return this.http.get(`${environment.webforms_api}/v1/loyalty_clubs/legal_information`,
      { headers: this.prepareHeaders() })
      .pipe(
        map((data: { legal_information: ApiLegalDocuments }) => toCamelCasedKeys(data.legal_information)),
      );
  }

  constructor(private http: HttpClient,
              private baseParamsService: BaseParamsService) {}

  private prepareHeaders(): HttpHeaders {
    return new HttpHeaders({
      [LOYALTY_CLUB_SLUG_HEADER]: this.baseParamsService.slug,
      [LOCALE_HEADER]: this.baseParamsService.language || '',
    });
  }

}
